<div class="admin-about">
  <app-top-header [parent]="parent"
                  class="admin-header-container"></app-top-header>

  <app-header-and-description heading="TRANS__ABOUT_PRIMUS__INFORMATION_TITLE"
                              description="TRANS__ABOUT_PRIMUS__INFORMATION_DESCRIPTION">
    <div class="admin-row">
      <mat-card appearance="outlined" class="admin-column admin-card">
        <mat-card-header class="admin-card__header">
          <mat-card-title>{{'TRANS__ABOUT_PRIMUS__INFORMATION__TITLE' | translate}}</mat-card-title>
        </mat-card-header>

        <mat-card-content class="admin-card__content">
          @if (!useNewLayout) {
            <mat-list>
              <mat-list-item>
                <span class="admin-about__information-item-title">{{'TRANS__ABOUT_PRIMUS__VERSION' | translate}}</span>
                <span class="admin-about__information-item-content">
                    {{ 'TRANS__ABOUT_PRIMUS__BACKEND_VERSION' | translate }}: {{ version }}.
                  {{ 'TRANS__ABOUT_PRIMUS__FRONTEND_VERSION' | translate }}: {{ frontendVersion }}
                </span>
              </mat-list-item>

              <mat-list-item>
                <span class="admin-about__information-item-title">{{'TRANS__ABOUT_PRIMUS__EDITION' | translate}}</span>
                <span class="admin-about__information-item-content" [translate]="edition.title"></span>
              </mat-list-item>

              <mat-list-item class="admin-about__user-manual-item">
                <span class="admin-about__user-manual-item-header">{{'TRANS__ABOUT_PRIMUS__USER_MANUAL_HEADLINE' | translate}}</span>
                @if (userManual) {
                  @for (manual of userManual.manuals; track $index) {
                    <div class="admin-about__user-manual-item-button-container">
                      <a mat-button
                         class="text-primary"
                         [href]="manual.href" target="_blank">
                        <i class="icon-file-pdf"></i>
                        <span [translate]="manual.title"></span></a>
                    </div>
                  }
                }
              </mat-list-item>
            </mat-list>
          } @else {
            <div class="admin-information--new-layout">

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ABOUT_PRIMUS__INSTANCE' | translate }}
                </span>
                <div>
                  <div></div>
                  <span class="admin-information__item-value">
                    {{ museum.name }}
                  </span>
                </div>
              </div>

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ABOUT_PRIMUS__VERSION' | translate }}
                </span>
                <div>
                  <div></div>
                  <span class="admin-information__item-value">
                    {{ 'TRANS__ABOUT_PRIMUS__BACKEND_VERSION' | translate }}: {{ version }}.
                    {{ 'TRANS__ABOUT_PRIMUS__FRONTEND_VERSION' | translate }}: {{ frontendVersion }}
                  </span>
                </div>
              </div>

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ABOUT_PRIMUS__EDITION' | translate }}
                </span>
                <div>
                  <div></div>
                  <span class="admin-information__item-value">
                    {{ edition.title | translate }}
                  </span>
                </div>
              </div>
            </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" class="admin-column admin-card">
        <mat-card-header class="admin-card__header">
          <mat-card-title>{{'TRANS__ADMIN__HELP__TITLE' | translate}}</mat-card-title>
        </mat-card-header>

        <mat-card-content class="admin-card__content">
          @if (!useNewLayout) {
            <mat-list>
              <mat-list-item><span class="bold">{{'TRANS__ADMIN__HELP__CONTACT' | translate}}</span></mat-list-item>
              <mat-list-item><span>{{'TRANS__ADMIN__HELP__NUMBER' | translate}}</span></mat-list-item>
              <mat-list-item><span>{{'TRANS__ADMIN__HELP__MAIL' | translate}}</span>
                <a class="admin-email text-primary-hover"
                   href="mailto:support@kulturit.no">support&#64;kulturit.no</a></mat-list-item>
            </mat-list>
          } @else {
            <div class="admin-information--new-layout">
              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ADMIN__HELP__PHONE' | translate }}
                </span>
                <div>
                  <span class="admin-information__item-value">
                    {{ 'TRANS__ADMIN__HELP__NUMBER' | translate }}
                  </span>
                </div>
              </div>

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ADMIN__HELP__MAIL' | translate }}
                </span>
                <div>
                  <span class="admin-information__item-value">
                    <a class="admin-about__link" href="mailto:support@kulturit.no" target="_blank">support&#64;kulturit.no</a>
                  </span>
                </div>
              </div>

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ADMIN__HELP__ONLINE' | translate }}
                </span>
                <div>
                  <span class="admin-information__item-value">
                    <a class="admin-about__link" href="https://support.museumsit.no" target="_blank">KulturIT support</a>
                  </span>
                </div>
              </div>

              <div class="admin-information__item">
                <span class="admin-information__item-header">
                  {{ 'TRANS__ADMIN__HELP__COURSES_AND_GUIDES' | translate }}
                </span>
                <div>
                  <span class="admin-information__item-value">
                    <a class="admin-about__link" href="https://akademi.ekultur.org/bundles/primusdokumentasjon" target="_blank">{{ 'TRANS__ADMIN__HELP__EKULTUR_AKADEMI' | translate }}</a>
                  </span>
                </div>
              </div>

              @if (userManual) {
                <div class="admin-information__item">
                  <span class="admin-information__item-header">
                    {{ 'TRANS__ABOUT_PRIMUS__USER_MANUAL_HEADLINE' | translate }}
                  </span>
                  <div>
                    @for (manual of userManual.manuals; track $index) {
                      <span class="admin-information__item-value">
                        <a class="admin-about__link" [href]="manual.href" target="_blank">{{ manual.title | translate }}</a>
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>

  </app-header-and-description>
</div>
